import axios from '../../axiosInstances/axiosInstance';

export const updateUserFave = (faveId, basketid, description) => {
  return axios.put(`/users/favoriteOrders/${faveId}`, { basketid, description });
};
